import HttpClient from './HttpClient';

class UserController {
  createInterestedUser = (name, email, phone, subject, contactMessage) => {
    const result = HttpClient.post(
      `/interested_users`,
      {
        name,
        email,
        phone,
        subject,
        contactMessage
      }
    );
    return result;
  };
}

export default new UserController();
